/**
 * pontosDaCompeticao — a única pontuação que o app mostra.
 *
 * ANTES HAVIA DUAS. O registro de treino calculava um `points` local
 * (`utils/pointsConfig.js::calcPoints`, com pesos por modalidade e bônus de
 * volume) e a competição creditava outra coisa. As duas apareciam na mesma
 * tela — 391 pts na linha da atividade, 146 pts no cabeçalho — e a maior era a
 * que não valia nada. A pontuação local saiu da interface: ela continua
 * existindo dentro do check-in porque o campo `points` vai no documento, mas
 * não é mais mostrada em lugar nenhum.
 *
 * A REGRA É DE PRODUTO E FIXA. Espelha
 * `functions/vita/competitionVita.js` (§ "PONTUAÇÃO DA EQUIPE"), onde está
 * escrito que estes valores NÃO são editáveis pelo dono da academia:
 *
 *     check-in de treino → +20 pts fixos + todo o XP gerado (1 XP = 1 pt)
 *     registro de dieta  → +10 pts fixos + o XP da refeição
 *     qualquer outro XP  → 1 XP = 1 pt
 *
 * QUANDO USAR A PREVISÃO E QUANDO NÃO. O número que vale é sempre o do
 * servidor: `getPontosRegistro` (o líquido do ledger) ou o `pontos` que a
 * criação do evento devolve — os dois já trazem bônus fixo e impulso de
 * equipe. `pontosPrevistos` só entra quando não há evento nenhum para
 * consultar, que é o caso de quem ainda não está em competição. É projeção,
 * e a interface diz isso.
 */

/** Bônus fixo por tipo de registro. Espelho da regra do servidor. */
export const PONTOS_FIXOS = { TREINO: 20, DIETA: 10 };

/**
 * Quanto um registro valeria na competição. NÃO substitui o valor do
 * servidor — é o que mostrar para quem ainda não entrou num clube.
 *
 * Sem impulso de equipe de propósito: o multiplicador é do time, e quem não
 * está em competição não tem time. Prometer 2× aqui seria prometer o que a
 * pessoa não vai receber.
 *
 * @param {object} args `{ tipo: 'TREINO'|'DIETA', xp }`
 * @return {number} pontos inteiros, nunca negativos.
 */
export function pontosPrevistos({ tipo, xp } = {}) {
  const fixo = PONTOS_FIXOS[tipo] || 0;
  const doXp = Math.max(0, Math.round(Number(xp) || 0));
  return fixo + doXp;
}

/**
 * O convite para quem não está em competição. Curto de propósito: divide
 * espaço com o número, e o número é o que convence.
 */
export const CONVITE_SEM_COMPETICAO =
  'Esses pontos somam no seu clube ou desafio — entre em um para pontuar.';

/** Rótulo único do bloco, para as três telas não divergirem. */
export const ROTULO_PONTOS = 'Pontos na competição';
